import Vue from 'vue'
export default {
  methods: {
    timeConvert: date => Vue.prototype.$dataTime(date),
    timeConvertWhatsapp: date => Vue.prototype.$timeConvertWhatsapp(date),
    timeConvertBackEnd: date => Vue.prototype.$timeConvertBackEnd(date),
    onlyDate: date => Vue.prototype.$onlyDate(date),
    onlyTime: date => Vue.prototype.$onlyTime(date)
  }
}
